module.exports = __webpack_public_path__ + "assets/b76b8bdf9a782fc7efad298b371cec8a.png";